import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Routes} from '../../utilities';

import * as styles from './Footer.scss';

import Logo from './svg/logo-inverse.svg';

interface OwnProps {}

type ComposedProps = WithI18nProps & OwnProps;

function Footer({i18n}: ComposedProps) {
  return (
    <footer className={styles.Footer}>
      <div className={styles.Container}>
        <div className={styles.LinksContainer}>
          <a href={Routes.termsOfServiceUrl()} className={styles.Link}>
            {i18n.translate('Global.Footer.terms')}
          </a>
          <a href={Routes.privacyPolicyUrl()} className={styles.Link}>
            {i18n.translate('Global.Footer.privacyPolicy')}
          </a>
          <a href={Routes.referralUrl('footer')} className={styles.Link}>
            {i18n.translate('Global.Footer.shopifyDomain')}
          </a>
        </div>
        <img src={Logo} alt={i18n.translate('Global.Header.logoAlt')} />
      </div>
    </footer>
  );
}

export default withI18n()(Footer);
